import ApiWrapper from "@/services/ApiWrapper";

var UserAccountService = {
    getUsersRegistrationInfo() {
        return ApiWrapper.post('/api/manage/Account/GetUsersRegistrationInfo');
    }
}

export default UserAccountService
